import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from "./router/routes.js"
import Axios from "axios"
import store from './store'
import navbarComponent from "./components/NavbarComponent.vue";

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = true
Vue.prototype.$hostname = (Vue.config.productionTip) ? 'http://kt-nlp-demo.ijs.si:5001' : 'http://95.87.154.196:5001'
//Vue.prototype.$hostname = 'http://95.87.154.196:5001'
Vue.prototype.$http = Axios;
Vue.component('navbarComponent', navbarComponent)
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')




